import type { ExactState } from "../core/wire.js";

// Paint-only connectivity over the received board. Never used for legality,
// captures, liberties, scoring, or a predicted next state.
export function stoneDecoration(state: ExactState) {
  const glow = new Set<number>();
  const diagonals: { from: number; to: number; color: "BLACK" | "WHITE"; connected: boolean }[] = [];
  if (state.phase !== "COLLAPSE_PLAY" || state.settlement.completed) return { glow, diagonals };
  const size = state.boardSize;
  const eight = (i: number) => state.cells[i]?.source?.originKind === "EIGHTWAY";
  for (let i = 0; i < state.cells.length; i++) {
    const cell = state.cells[i]!;
    if (cell.color === null || !eight(i)) continue;
    const x = i % size, y = Math.floor(i / size);
    for (const dx of [-1, 1]) for (const dy of [-1, 1]) {
      const nx = x + dx, ny = y + dy;
      if (nx < 0 || nx >= size || ny < 0 || ny >= size) continue;
      const to = ny * size + nx;
      if (eight(to) && state.cells[to]!.color === cell.color && to < i) continue;
      diagonals.push({ from: i, to, color: cell.color, connected: state.cells[to]!.color === cell.color });
    }
  }
  const queue: number[] = [];
  state.cells.forEach((cell, i) => {
    if (cell.color !== null && cell.source?.originKind === "IMMORTAL") { glow.add(i); queue.push(i); }
  });
  for (let cursor = 0; cursor < queue.length; cursor++) {
    const i = queue[cursor]!, x = i % size, y = Math.floor(i / size);
    for (const dx of [-1, 0, 1]) for (const dy of [-1, 0, 1]) {
      if (dx === 0 && dy === 0) continue;
      const nx = x + dx, ny = y + dy;
      if (nx < 0 || nx >= size || ny < 0 || ny >= size) continue;
      const to = ny * size + nx;
      if (dx !== 0 && dy !== 0 && !eight(i) && !eight(to)) continue;
      if (!glow.has(to) && state.cells[to]!.color === state.cells[i]!.color) {
        glow.add(to); queue.push(to);
      }
    }
  }
  return { glow, diagonals };
}
